type SearchType = {
  fill: string
  width: string
  height: string
  title: string
}

function Search(props: SearchType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'search'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
    >
      <title>{title}</title>
      <path
        d='M12.8413 12.8418L17.4997 17.5002'
        stroke={fill}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M8.27509 14.7328C11.8413 14.7328 14.7323 11.8418 14.7323 8.27558C14.7323 4.70936 11.8413 1.81836 8.27509 1.81836C4.70887 1.81836 1.81787 4.70936 1.81787 8.27558C1.81787 11.8418 4.70887 14.7328 8.27509 14.7328Z'
        stroke={fill}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default Search
